<template>
    <div class="searchBox width_min flex_a_c">
        <div class="width_auto flex flex_j_sb flex_a_c">
            <div class="flex_a_c">
                <div style="margin: 32px 40px 0 0;">
                    <img src="@/assets/images/logo2.png" alt="">
                </div>
                <div class="">
                    <div class="searchBox_Slogan">
                        <img style="width: 321px; height: 38px;" src="@/assets/images/slogan.gif" alt="">
                    </div>
                    <div class="flex_a_c gap_20">
                        <el-input
                            class="searchInputHome"
                            placeholder="请输入内容"
                            @keyup.enter.native="searchPro"
                            v-model="keyword">
                            <template slot="prefix">
                                <el-dropdown @command="searchCommand" trigger="click">
                                <span class="cur_p">{{ searchVal }}
                                    <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="商品">商品</el-dropdown-item>
                                    <el-dropdown-item command="店铺">店铺</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            </template>
                            <template slot="suffix">
                                <el-button class="btn_584DFF" style="width: 98px;height: 34px;" @click="searchPro">搜索</el-button>
                            </template>
                        </el-input>
                        <div class="searchBox_YYai">
                            <img src="@/assets/images/Icon/YYai.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 43px;">
                <img src="@/assets/images/HourByHour.png" alt="" style="width:270px">
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
    name: 'Search',
    data () {
        return {
            selectedValue: '',
            selectedValueId: '',
            keyword: '',
            searchVal: '商品',
            categoryList: []
        }
    },
    computed: {
    ...mapGetters([
      'searchObj'
    ])
  },
    mounted () {
        if (this.searchObj.keyword !== undefined) {
            this.keyword = this.searchObj.keyword
            this.searchVal = this.searchObj.searchVal
        }
    },
    methods: {
        ...mapMutations({
            setSearchObj: 'SET_SEARCHOBJ'
        }),
        searchCommand (command) {
            this.searchVal = command
        },
        // 查找
        searchPro () {
            if (!this.keyword) { return this.$message.error('请输入搜索内容') }
            this.setSearchObj({
                keyword: this.keyword,
                searchVal: this.searchVal
            })
            if (this.$route.name !== 'search') {
                this.$router.push({
                    path: '/activity/search'
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.searchBox {
    background: #F4F8FE;
    height: 132px;
    .searchBox_Slogan{
        text-align: center;
        margin-bottom: 16px;
    }
    .searchBox_YYai{
        width: 98px;
        height: 40px;
        border: 2px solid #FE0505;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
}

.SelectInput {
    width: 620px;
}

.SelectInput>>>.el-input__inner {
    background: #FFFFFF;
    border-radius: 6px 0px 0px 6px;
    border: 1px solid;
    border-image: linear-gradient(90deg, rgba(88, 77, 255, 1), rgba(24, 102, 237, 1)) 2 2;
    height: 48px;
    width: 620px;
}

.SelectBtn {
    width: 80px;
    height: 48px;
    background: linear-gradient(90deg, #584DFF 40%, #1866ED 100%);
    font-size: 16px;
    color: #FFFFFF;
    border-radius: 0px 6px 6px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Search.vue